import { FC } from 'react'

/**
 * @function StarIcon - компонент иконки звезды с градиентом
 */
export const StarIcon: FC = () => (
  <svg width='27' height='26' viewBox='0 0 27 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.73386 3.51496C9.84496 2.87787 10.7595 2.87788 10.8706 3.51496L11.4139 6.63093C11.6648 8.06922 12.791 9.19551 14.2293 9.44633L17.3453 9.98972C17.9824 10.1008 17.9824 11.0153 17.3453 11.1264L14.2293 11.6698C12.791 11.9206 11.6648 13.0469 11.4139 14.4852L10.8706 17.6012C10.7595 18.2383 9.84496 18.2383 9.73386 17.6012L9.19047 14.4852C8.93965 13.0469 7.81336 11.9206 6.37507 11.6698L3.2591 11.1264C2.62202 11.0153 2.62202 10.1008 3.2591 9.98972L6.37507 9.44633C7.81336 9.19551 8.93965 8.06922 9.19047 6.63093L9.73386 3.51496Z'
      fill='url(#paint0_linear_822_309935)'
    />
    <path
      d='M19.4317 15.2591C19.5428 14.622 20.4572 14.622 20.5683 15.2591L20.6214 15.5632C20.8722 17.0015 21.9985 18.1278 23.4368 18.3786L23.7409 18.4317C24.378 18.5428 24.378 19.4572 23.7409 19.5683L23.4368 19.6214C21.9985 19.8722 20.8722 20.9985 20.6214 22.4368L20.5683 22.7409C20.4572 23.378 19.5428 23.378 19.4317 22.7409L19.3786 22.4368C19.1278 20.9985 18.0015 19.8722 16.5632 19.6214L16.2591 19.5683C15.622 19.4572 15.622 18.5428 16.2591 18.4317L16.5632 18.3786C18.0015 18.1278 19.1278 17.0015 19.3786 15.5632L19.4317 15.2591Z'
      fill='url(#paint1_linear_822_309935)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_822_309935'
        x1='10.3022'
        y1='0.255859'
        x2='10.3022'
        y2='20.8603'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#345DFF' />
        <stop offset='1' stopColor='#FF65E3' />
      </linearGradient>
      <linearGradient id='paint1_linear_822_309935' x1='20' y1='12' x2='20' y2='26' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#345DFF' />
        <stop offset='1' stopColor='#FF65E3' />
      </linearGradient>
    </defs>
  </svg>
)
